import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { Subject, takeUntil } from "rxjs";
import { map } from "rxjs/operators";
import { RaskRoller } from "~app/common/models/constants";
import { canEdit, canView, updatePermissions } from "~app/role-permissions";
import { VirkeskopKontraktstyp } from "../../models/kontrakt-models";
import { AtgardMediatorService } from "../../services/atgard-mediator.service";
import { KontraktMediatorService } from "../../services/kontrakt-mediator.service";
import { VirkeskostnaderUtbyteService } from "../../services/virkeskostnader-utbyte.service";
import { AtgardAvverkningskostnadComponent } from "./atgard-avverkningskostnad/atgard-avverkningskostnad.component";
import { AtgardVirkeskostnadComponent } from "./atgard-virkeskostnad/atgard-virkeskostnad.component";
import { ForkalkylNettoberakningComponent } from "./forkalkyl-nettoberakning/forkalkyl-nettoberakning.component";
import { ForkalkylTradslagComponent } from "./forkalkyl-tradslag/forkalkyl-tradslag.component";
@Component({
    selector: "rask-atgard-forkalkyl",
    templateUrl: "./atgard-forkalkyl.component.html",
    styleUrls: ["./atgard-forkalkyl.component.scss"],
    providers: [
        updatePermissions({
            role: RaskRoller.role.Kopplanera,
            canEdit: false,
            canView: false
        }),
        VirkeskostnaderUtbyteService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TabsComponent,
        TabComponent,
        ForkalkylTradslagComponent,
        AtgardVirkeskostnadComponent,
        AtgardAvverkningskostnadComponent,
        ForkalkylNettoberakningComponent
    ]
})
export class AtgardForkalkylComponent implements OnInit, OnDestroy {
    protected kontraktReadonly = false;
    protected canView = canView();

    private readonly atgardMediatorService = inject(AtgardMediatorService);
    private readonly kontraktMediatorService = inject(KontraktMediatorService);
    private readonly ngUnsubscribe$ = new Subject<void>();

    private readonly canEdit = canEdit();

    get atgard() {
        return this.atgardMediatorService.atgard;
    }

    get iskontraktTypGrot(): boolean {
        return this.kontrakt.kontraktTyp === VirkeskopKontraktstyp.Grot;
    }

    get kontrakt() {
        return this.kontraktMediatorService.kontrakt;
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit(): void {
        this.kontraktMediatorService.isReadonly$.pipe(
            map(readonly => readonly || !this.canEdit()),
            takeUntil(this.ngUnsubscribe$)
        ).subscribe(readonly => this.kontraktReadonly = readonly);
    }
}
